import { createStore } from 'vuex';
import { createVuexPersistedState } from 'vue-persistedstate';

import loginModule from './modules/login-module.js';
import remoteVehicle from './modules/remoteVehicle-module.js';
import IotResult from './modules/IotResult-module.js';
import remoteHistory from './modules/remoteHistory-module.js';
import regiSave from './modules/regi-save.js';

const store = createStore({
	plugins: [
		createVuexPersistedState({
			key: 'vuexStore',
			storage: window.localStorage,
		}),
	],
	state() {
		return {
			lang: 'ko', // 다국어 언어 관련
			dataItems: [], // 페이지 탭 생성에 대한 데이터 정보
			conItems: null, // 현재 페이지 탭의 데이터 정보(미사용?)
			activeMenu: null, // 현재 활성화 되어 있는 메뉴 키 정보
			vinId: null, // 현재 페이지의 파라미터 ID (?)
			iotState: null, // 원격진단 관련
			currentPage: 1, // 목록 현재 페이지
			currentTabPage: 1, // 탭 상세 현재 페이지
			currentPage4: 1, // 메인페이지 소모품품 현재 페이지
			testing: null, // test suceess, faild, timeout 등의 상태변화를 저장
			testValid : null, // 현재 테스트 중인 테스트의 type을 상태로 저장
			temp : [], // 쓰는 곳 있는 지 확인 필요
			params : {}, // 검색 했을 때 파라미터 정보
			axiosMid : null, // 원격진단 mid 파라미터 정보
			credentialsNonExpired: true, // 로그인 할 때 로그인 만료 여부
			axiosLoading: false, // axios 요청 시 로딩 바 관련
			groupId: null, // 현재 로그인 된 그룹 아이디 (본부 선택 시 계속 해서 바뀜)
			loginGroup: null, // 현재 로그인 된 그룹 아이디 (절때 바뀌지 않음)
			permission : null, // 접근권한데이터 저장
			popupGroupId: null, //현재 팝업창에서 선택된 그룹아이디
			listGroupId: null, //리스트에서 선택된 그룹아이디 - 상세와 분리처리
		};
	},
	mutations: {
		setLocale(state, newLocale) {
			state.lang = newLocale;
			localStorage.setItem('locale', newLocale);
		},
		addDataItem(state, item) {
			state.dataItems.push(item);
		},
		addConItems(state, item) {
			state.conItems = item;
		},
		deleteDataItem(state, itemToDelete) {
			let index;
			if (itemToDelete.page == 'customerVehicleModi') {
				index = state.dataItems.findIndex(item => 
					item.number === itemToDelete.number &&
					item.page === itemToDelete.page
				);
			} else {
				index = state.dataItems.findIndex(item => 
					item.no === itemToDelete.no && 
					item.number === itemToDelete.number &&
					item.page === itemToDelete.page
				);
			}
			if (index !== -1) {
			  	state.dataItems.splice(index, 1);
			}
		},
		clearDataItems(state) {
			state.dataItems = [];
		},
		clearConItems(state) {
			state.conItems = null;
		},
		setActiveMenu(state, menuKey) {
			state.activeMenu = menuKey;
		},
		setVinId(state, item) {
			state.vinId = item;
		},
		setIotState(state, item) {
			state.iotState = item;
		},
		clearIotState(state){
			state.iotState = null;
		},
		setCurrentPage(state, page) {
			state.currentPage = page;
		},
		setCurrentPage4(state, page) {
			state.currentPage4 = page;
		},
		setCurrentTabPage(state, page) {
			state.currentTabPage = page;
		},
		setTesting(state, item){
			state.testing = item;
		},
		setCredential(state, item){
			state.credentialsNonExpired = item;
		},
		clearTesting(state, item){
			state.testing = null;
		},
		setTemp(state, item){
			state.temp.push(item);
		},
		clearTemp(state) {
			state.temp = [];
		},
		updateParams(state, newParams) {
			state.params = { ...state.params, ...newParams };
		},
		resetParams(state) {
            state.params = {};
		},
		setAxiosMid(state, item) {
			state.axiosMid = item;
		},
		clearAxiosMid(state) {
			state.axiosMid = null;
		},
		setTestValid(state, item) {
			state.testValid = item;
		},
		clearTestValid(state) {
			state.testValid = null;
		},
		setAxiosLoading(state, item) {
			state.axiosLoading = item;
		},
		setGroupId(state, item) {
			state.groupId = item;
		},
		setLoginGroup(state, item) {
			state.loginGroup = item;
		},
		setPermission(state, item) {
			state.permission = item
		},
		setGroupType(state, item) {
			state.groupType = item
		},
		clearPermission(state) {
			state.permission = null;
		},
		setPopupGroupId(state, item) {
			state.popupGroupId = item;
		},
		setListGroupId(state, item) {
			state.listGroupId = item;
		},
		clearListGroupId(state) {
			state.listGroupId = null;
		}
	},
	actions: {
		addDataItem({ commit }, item) {
			commit('addDataItem', item);
		},
		addConItems({ commit }, item) {
			commit('addConItems', item);
		},
		clearDataItems({ commit }) {
			commit('clearDataItems');
		},
		clearConItems({ commit }) {
			commit('clearConItems');
		},
		setActiveMenu(context, menuKey) {
			context.commit('setActiveMenu', menuKey);
		},
		setVinId({ commit }, item) {
			commit('setVinId', item);
		},
		setIotState({ commit }, item) {
			commit('setIotState', item);
		},
		clearIotState({ commit }){
			commit('clearIotState');
		},
		setCurrentPage({ commit }, item) {
			commit('setCurrentPage', item);
		},
		setCurrentPage4({ commit }, item) {
			commit('setCurrentPage4', item);
		},
		setCurrentTabPage({ commit }, item) {
			commit('setCurrentTabPage', item);
		},
		setTesting({ commit }, item){
			commit('setTesting', item);
		},
		setCredential({ commit }, item){
			commit('setCredential', item);
		},
		clearTesting({ commit }){
			commit('clearTesting');
		},
		setTemp({ commit }, item){
			commit('setTemp', item);
		},
		clearTemp({ commit }) {
			commit('clearTemp');
		},
		setParams({ commit }, newParams) {
			commit('updateParams', newParams);
		},
		resetAllParams({ commit }) {
			commit('resetParams');
		},
		setAxiosMid({ commit }, item){
			commit('setAxiosMid', item);
		},
		clearAxiosMid({ commit }){
			commit('clearAxiosMid');
		},
		setTestValid({ commit }, item){
			commit('setTestValid', item);
		},
		clearTestValid({ commit }){
			commit('clearTestValid');
		},
		setAxiosLoading({ commit }, item) {
			commit('setAxiosLoading', item);
		},
		setGroupId({ commit }, item) {
			commit('setGroupId', item);
		},
		setLoginGroup({ commit }, item) {
			commit('setLoginGroup', item);
		},
		setPermission({ commit }, item) {
			commit('setPermission', item);
		},
		setGroupType({ commit }, item) {
			commit('setGroupType', item);
		},
		clearPermission({ commit }) {
			commit('clearPermission');
		},
		setPopupGroupId({ commit }, item) {
			commit('setPopupGroupId', item);
		},
		setListGroupId({ commit }, item){
			commit('setListGroupId', item);
		}
	},
	getters: {
		getVinId: state => state.vinId,
		getIotState: state => state.iotState,
		getTesting: state => state.testing,
		getTemp: state => state.temp,
		getConItems: state => state.conItems,
		getAxiosMid : state => state.axiosMid,
		getTestValid : state => state.testValid,
		getLogingroup : state => state.loginGroup,
		getDataItems : state => state.dataItems,
		getGroupId : state => state.groupId,
		getPermission : state => state.permission,
		getGroupType : state => state.groupType,
		getPopupGroupId : state => state.popupGroupId,
		getListGroupId : state => state.listGroupId,
	},
	modules: {
		loginModule,
		remoteVehicle,
		IotResult,
		remoteHistory,
		regiSave,
	},
});

export default store;
